<template>
  <div class="recordView">
  
    <div class="row">
      <div class="col s12 l10 push-l1">
        <div class="contents" v-if="post">

      <div class="tools-bar" ref="pinme">
        
          <div class="col">
            <button 
            @click="$router.go(-1)"
            class="btn-floating btn-small white z-depth-0 waves-effect">
              <i class="material-icons grey-text text-darken-4">
                arrow_back
              </i>
            </button>
          </div>
            <div class="record-title col no-padding">
              {{post.title.rendered}} - {{post.acf.subject}}
            </div>
            <div class="col right">
            <button 
             v-tipped
             :disabled="true"
            data-tooltip="Delete Record"
            class="btn-floating btn-small white z-depth-0 waves-effect tooltipped">
              <i class="material-icons grey-text text-darken-4">
               delete
              </i>
            </button>
          </div>
          <div class="col right">
            <button
            @click="$_isEdting()"
             v-tipped
            data-tooltip="Enable Editing"
             class="btn-floating btn-small white z-depth-0 waves-effect tooltipped">
              <i class="material-icons grey-text text-darken-4">
               edit
              </i>
            </button>
          </div>
          <div class="col right">
            <button 
            :disabled="editing"
            @click="$_updateRecord()" 
            v-tipped
            data-tooltip="Save Changes"
            class="btn-floating btn-small white z-depth-0 waves-effect tooltipped">
              <i class="material-icons grey-text text-darken-4">
              save
              </i>
            </button>
          </div>
          <span class="chip right" 
							v-bind:class="[post.acf.type.name === 'Incoming' ? 'green accent-4' : 'purple accent-4']"
							v-html="post.acf.type.name"></span>
         
          <div class="clear"></div>
        </div>


          <div class="col s12">
           
            
        </div>
        <div class="clear"></div>
      
  <transition name="fade-in">
         <div class="record notes" v-if="ready">
          <div 
            :class="field.layout"
            v-for="(field, key, index,) in post_fields" v-bind:key="index">
              <field-types
                @update="$_editInVuex($event)"
                :global-disabled="editing"
                :data-option="$_mapFields(field.label,field.value)"
              >
            </field-types>
          </div>
          
         </div>
           </transition>
        </div>
      </div>
    </div>
  
  </div>
</template>
<script>
import M from 'materialize-css'
import recordFields from '@/components/records/form/records-incoming'
import core from '@/functions'
import contentService from '@/services/contentService'
import fieldTypes from '@/components/records/fieldTypes.component'
import {mapState} from 'vuex'
export default {
  name:'recordView',
  data(){
    return {
      ready:false,
      letToUpdate: {},
      post_fields: new Array,
      editing:true,
      ...recordFields,
      pinnedElements:null,
      pinOptions:{
        top:50,
        offset:0,
        onPositionChange:()=>{
      
        }
      }
    }
  },
  components:{
    fieldTypes,
  },
  mounted(){
    this.$_setFields()
    core.updateFields()
    setTimeout(() => {
      this.ready = true
      this.$_init()
    }, 300);
  },
  watch:{
    'post.acf':function(nV){
      if(nV) this.$_setFields()
    }
  },
  computed:{
    ...mapState({
      records:state => state.record.records
    }),
    post:{
      get(){
        const record = this.records.findIndex(item => item.id === parseInt(this.$route.params.id))
        return record > -1 ? this.records[record] : false
      },
      set(payload){
        setTimeout(() => {
          this.$store.commit('UPDATE_RECORD', payload)
        }, 300);
      }
    },
    post_fieldz:{
      get(){
        const fieldsStructure = (post) =>{
       
            return [
              {
                label:'name',
                value:post.name,
                layout:'col s12'
              },
              {
                label:'type',
                value:post.type,
                layout:'col s6'
              },
              {
                label:'category',
                value:post.category,
                layout:'col s6'
              },
              {
                label:'from',
                value:post.from,
                layout:'col s6'
              },
              {
                label:'to',
                value:post.to,
                layout:'col s6'
              },
              {
                label:'date_stamp',
                value:post.date_stamp,
                layout:'col s6'
              },
              {
                label:'date_corres',
                value:post.date_corres,
                layout:'col s6'
              },
              {
                label:'subject',
                value:post.subject,
                layout:'col s12'
              },
              {
                label:'comments',
                value:post.comments,
                layout:'col s6'
              },
              {
                label:'stamps',
                value:post.stamps,
                layout:'col s6'
              },
              {
                label:'attachments',
                value:post.attachments,
                layout:'col s12'
              },
              {
                label:'contents',
                value:post.contents ? post.contents : new Array,
                layout:'col s12'
              },
              {
                label:'routes',
                value:post.routes ? post.routes : new Array ,
                layout:'col s12'
              },
              {
                label:'notes',
                value:post.notes,
                layout:'col s12'
              },
              
            ]
          
        }
        return fieldsStructure(this.post.acf)
      }
    }
  },
  methods:{
    $_setFields(){
 const fieldsStructure = (post) =>{
       
            return [
              {
                label:'name',
                value:post.name,
                layout:'col s12'
              },
              {
                label:'type',
                value:post.type,
                layout:'col s6'
              },
              {
                label:'category',
                value:post.category,
                layout:'col s6'
              },
              {
                label:'from',
                value:post.from,
                layout:'col s6'
              },
              {
                label:'to',
                value:post.to,
                layout:'col s6'
              },
              {
                label:'date_stamp',
                value:post.date_stamp,
                layout:'col s6'
              },
              {
                label:'date_corres',
                value:post.date_corres,
                layout:'col s6'
              },
              {
                label:'subject',
                value:post.subject,
                layout:'col s12'
              },
              {
                label:'comments',
                value:post.comments,
                layout:'col s6'
              },
              {
                label:'stamps',
                value:post.stamps,
                layout:'col s6'
              },
              {
                label:'attachments',
                value:post.attachments,
                layout:'col s12'
              },
              {
                label:'contents',
                value:post.contents ? post.contents : new Array,
                layout:'col s12'
              },
              {
                label:'routes',
                value:post.routes ? post.routes : new Array ,
                layout:'col s12'
              },
              {
                label:'notes',
                value:post.notes,
                layout:'col s12'
              },
              
            ]
          
        }
        this.post_fields =  fieldsStructure(this.post.acf)
        
    },
    $_updateRecord(){
      this.editing = true
      let payload = {
        fields:this.letToUpdate
      }
      contentService.updateRecord(payload, this.post.id)
      .then(res => {
        core.toastMessage('Update Successfully', ()=>{
          window.console.log(res.data)
        })
      })
      .catch(err=>{
        core.toastMessage('Opps something went wrong',()=>{
          window.console.log(err)
        })
      })
    },
    $_isEdting(){
      this.editing === true 
      ? this.editing = false 
      : this.editing = true
    },
    $_editInVuex($event) {
      this.$set(this.letToUpdate, $event.name, $event.name === 'from' || $event.name === 'to' ? $event.data.id : $event.data)

 /*      let payload = {
        data:$event.name === 'from' || $event.name === 'to' ? $event.data.id : $event.data ,
        prop:$event.name,
        id:this.post.id,
      } */
      //this.post = payload
     //this.$_setFields()
      
    },
    $_mapFields(prop, value){
      const record = this.fields.find(field => field.name === prop)
      //record.values = value 
      const newValues = {...record}
      newValues.values = value
      return newValues
    },
  $_setPin(){
  this.pinnedElements = M.Pushpin.init(this.$refs.pinme, this.pinOptions);
  },
/*   $_init(){
    this.pinOptions.top = document.querySelector('.tools-bar').offsetTop
    this.$_setPin()
  } */
  }
}
</script>
<style lang="scss" scoped>
.recordView {
  .tools-bar {
    padding:8px 0px;
  }
  .record-title {
    font-size: 20px;
    margin:0 12px 0;
  }
}
</style>
<style lang="scss" >
.recordView {
  .input-field>label {
    //  top: 0;
      left: 10px;
      width: auto;
      background: white;
      &.active {
        
        margin-top: 5px;
        width: auto;
        }
      }
    input[type=text]:not(.dropdown-trigger), 
    input[type=text]:not(.browser-default), 
    input[type=number]:not(.browser-default), 
    input[type=email]:not(.browser-default), 
    input[type=select]:not(.browser-default){
      border: 1px solid rgba(158, 158, 158, 0.35);
      width: calc(100% - 16px);
      margin: 0 0 8px 0;
      padding: 0 8px;
      border-radius:4px;
    }
    textarea.materialize-textarea{
      box-shadow:none !important;
      border-radius:4px;
      border: 1px solid rgba(158, 158, 158, 0.35);
      margin: 0 0 8px 0;
      padding: 16px;
      min-height: 80px;
    }
    .custom-modal {
      @media screen and (min-width:1024px){
        transform:translate(calc(-50% + 100px), -50%);
      }
    }
    .tools-bar {
      &.pinned {
        top: 38px !important;
        z-index: 9;
        background: white;
        width: calc(100% - 18px);
      }
    }
}

</style>